module.exports = __webpack_public_path__ + "img/founder.e2cf95ba.png";